import { Link, Typography } from '@mui/material'
import { ExactScopeName, useHasScope } from '~hooks/permissions/use-has-scope'
import { getEquivalentUrl } from '~utils/environment'
import { Environment, environmentToggle } from '~utils/feature-toggles'

export function GoToStageButton() {
  const isMTUser = useHasScope(ExactScopeName.maerskTankersUser)
  const isProduction = environmentToggle(Environment.Production)

  if (!isProduction || !isMTUser) {
    return null
  }

  const handleClick = () => {
    const stageUrl = new URL(getEquivalentUrl('stage'))
    stageUrl.searchParams.set('stagePreview', 'true')
    window.location.href = stageUrl.toString()
  }

  return (
    <Link
      component="button"
      onClick={handleClick}
      sx={{
        textDecoration: 'none',
        color: 'white',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      <Typography variant="menu" sx={{ color: 'white' }}>
        Go to Stage
      </Typography>
    </Link>
  )
}
